import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { Link } from 'gatsby';

import { media } from '../../helpers';
import Wrapper from '../../elements/wrapper';

const HomeSplitSectionContainer = styled.div`
    &.with-wave {
    }
    &.with-padding {
        padding: 10vh 0 0;
        ${media.medium`margin-top: -40vh;`}
    }

    &.flipped {
        .split-wrapper {
            .image-container {
                order: 1;
            }
            .content-container {
                order: 2;
            }
        }
    }
    .split-wrapper {
        ${media.medium`display: flex; align-items: center;`}
        ${media.large`max-width: 82.5vw;`}

        > .image-container {
            flex: 1;
            order: 2;
        }

        > .content-container {
            flex: 1;
            order: 1;
            text-align: center;

            > .inner-wrap {
                max-width: 90%;
                margin: 0 auto;
                padding-top: 20px;

                > h3 {
                    font-size: 3rem;
                    color: #000;
                    margin: 0 0 20px;
                    line-height: 1;
                    font-weight: 800;
                    font-family: neue-kabel, sans-serif;
                    ${media.medium`font-size: 3.5rem; margin: 0 0 40px;`}
                    ${media.large`font-size: 4rem;`}
                }

                > p {
                    font-size: 1.2rem;
                    line-height: 1.5;
                    max-width: 480px;
                    margin: 0 auto 30px;
                    ${media.medium`margin: 0 auto 60px;`}
                }

                .icons-grid {
                    margin: 0 auto 30px;
                    ${media.medium`display: flex; margin: 0 auto 60px;`}

                    .item-container {
                        flex: 1;
                        margin-bottom: 20px;
                        &:last-child {
                            margin-bottom: 0px;
                        }
                        ${media.medium`margin-bottom: 0px;`}
                        > .inner-wrap {
                            display: flex;
                            justify-content: center;
                            max-width: 90%;
                            margin: 0 auto;
                            ${media.medium`display: block;`}
                            .image-container {
                                max-width: 55px;

                                margin: 0 20px 10px 0;
                                order: 1;
                                flex: 1;
                                ${media.medium`margin: 0 auto 10px;`}
                                .gatsby-image-wrapper {
                                    max-height: 55px;

                                    img {
                                        object-fit: contain !important;
                                    }
                                }
                            }
                            .content-container {
                                order: 2;
                                text-align: left;
                                flex: 2;

                                ${media.medium`text-align: center;`}
                                h4 {
                                    margin: 0 0 5px;
                                    font-size: 1rem;
                                    ${media.medium`margin: 0 0 15px;`}
                                    ${media.laptop`font-size: 1.2rem;`}
                                }

                                p {
                                    font-size: 0.9rem;
                                    margin: 0;
                                }
                            }
                        }
                    }
                }

                .btn-container {
                    a {
                        color: #fff;
                        background-color: #f74d33;
                        text-decoration: none;
                        font-weight: bold;
                        font-size: 1.1rem;
                        border-radius: 5px;
                        line-height: 1;
                        display: inline-block;
                        padding: 20px 0;
                        max-width: 225px;
                        width: 100%;
                        font-weight: 800;
                        font-family: neue-kabel, sans-serif;
                    }
                }
            }
        }
    }
`;

const HomeSplitSection = ({ content, flipped }) => {
    const {
        splitSectionImage,
        splitSectionTitle,
        splitSectionCaption,
        splitSectionButton,
        splitSectionIcons,
    } = content || {};
    return (
        <HomeSplitSectionContainer
            className={flipped ? 'with-padding flipped' : 'with-wave'}
        >
            <Wrapper className="split-wrapper">
                <div className="image-container">
                    {splitSectionImage && (
                        <Img
                            fluid={
                                splitSectionImage.localFile.childImageSharp
                                    .fluid
                            }
                        />
                    )}
                </div>
                <div className="content-container">
                    <div className="inner-wrap">
                        <h3>{splitSectionTitle}</h3>
                        <p>{splitSectionCaption}</p>
                        <div className="icons-grid">
                            {splitSectionIcons &&
                                splitSectionIcons.map((icon) => {
                                    const { iconTitle, iconImage, iconBlurb } =
                                        icon || {};
                                    return (
                                        <div className="item-container">
                                            <div className="inner-wrap">
                                                <div className="image-container">
                                                    <Img
                                                        fluid={
                                                            iconImage.localFile
                                                                .childImageSharp
                                                                .fluid
                                                        }
                                                    />
                                                </div>
                                                <div className="content-container">
                                                    <div className="inner-wrap">
                                                        <h4>{iconTitle}</h4>
                                                        <p>{iconBlurb}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                        <div className="btn-container">
                            <Link to={splitSectionButton.url}>
                                {splitSectionButton.title}
                            </Link>
                        </div>
                    </div>
                </div>
            </Wrapper>
        </HomeSplitSectionContainer>
    );
};

export default HomeSplitSection;

// let colorFamily = [];
// let x = [...document.querySelectorAll('.uk-grid.gride > div')];

// x.map((div) => {
//     if (div.style.display !== 'none') {
//         colorFamily.push(div);
//     }
// });

// colorFamily.map((colorDiv) => {
//     console.log(colorDiv.querySelector('rect').style.fill);
// });

// colorFamily.map((colorDiv) => {
//     console.log(colorDiv.querySelector('p').textContent);
// });

// // console.log(colorFamily);x
